import geolocalization from './en/geolocalization.json';

let items = {
    ...geolocalization
}

export default items;